import Grid2 from "@mui/material/Grid2";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useCrafts } from "@/shared/catalogs/hooks/useCrafts";
import { useSearchParams } from "react-router-dom";
import { getCraftLetter } from "@/utils/craftLetter";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

type Props = {};

export const CraftsFilter = ({}: Props) => {
	const { crafts } = useCrafts();
	const [searchParams, setSearchParams] = useSearchParams();

	const parseCraftParams = (craftParam: string | null): string[] => {
		if (!craftParam) return ["A"];
		if (craftParam === "A") return ["A"];
		return craftParam.split(",").filter((craft) => craft.trim() !== "");
	};

	const craft = parseCraftParams(searchParams.get("craft"));

	const handleFilter = (event: any) => {
		const selectedValue = event.target.value;
		let newSelectedValues: string[] = [];
		if (Array.isArray(selectedValue)) {
			const lastSelected = selectedValue[selectedValue.length - 1];
			if (lastSelected === "A") {
				newSelectedValues = ["A"];
			} else if (selectedValue.includes("A") && craft.includes("A")) {
				newSelectedValues = [lastSelected];
			} else {
				newSelectedValues = selectedValue.filter((v) => v !== "A");
			}
		} else {
			newSelectedValues = [selectedValue];
		}

		if (newSelectedValues.length === 0 || newSelectedValues[0] === "A") {
			searchParams.set("craft", "A");
		} else {
			searchParams.set("craft", newSelectedValues.join(","));
		}

		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box
			sx={{
				marginTop: "3px",
				"& .MuiSelect-select": {
					backgroundColor: "#FFF",
					paddingTop: "6.5px",
					paddingBottom: "6.5px",
				},
			}}
		>
			{/* Outlined like the Types and Down hours filters beside it, so the labels line up */}
			<FormControl
				variant="outlined"
				size="small"
				sx={{
					width: "100%",
				}}
			>
				<InputLabel id="craft-multiple-chip-label" shrink>
					Crafts
				</InputLabel>
				<Select
					labelId="craft-multiple-chip-label"
					id="craft-multiple-chip"
					label="Crafts"
					notched
					multiple
					value={craft}
					onChange={handleFilter}
					renderValue={(selected) => (
						<Box
							sx={{
								display: "flex",
								flexWrap: "nowrap",
								gap: "4px",
								overflow: "hidden",
								maxWidth: "calc(100%)",
								minHeight: 24,
								alignItems: "center",
							}}
						>
							{(selected as string[]).map((craftId) => {
								const craftItem = crafts.find(
									(c) => c.id.toString() === craftId,
								);
								// Plain text like "All types" beside it; a chip is taller than the
								// text and touches the field label
								if (craftId === "A") {
									return <span key={`craft-${craftId}`}>All crafts</span>;
								}
								return (
									<div
										key={`craft-${craftId}`}
										style={{
											height: 20,
											width: 20,
											borderRadius: 4,
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											background: craftItem?.color || "#FFFFFF",
											marginRight: 4,
										}}
									>
										<div
											style={{
												color: "#FFF",
												fontWeight: 600,
												fontSize: "0.75rem",
											}}
										>
											{getCraftLetter(craftItem?.description, craftItem?.code)}
										</div>
									</div>
								);
							})}
						</Box>
					)}
					MenuProps={MenuProps}
				>
					<MenuItem value="A">All crafts</MenuItem>
					{crafts
						.filter((craft) => craft.id.toString() !== "A")
						.map((craft) => (
							<MenuItem key={`logId-${craft.id}`} value={craft.id.toString()}>
								<Grid2 container alignItems="center">
									<div
										style={{
											height: 20,
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
										}}
									>
										<div
											style={{
												height: 24,
												width: 24,
												borderRadius: 4,
												display: "flex",
												justifyContent: "center",
												alignItems: "center",
												background: craft.color || "#FFFFFF",
											}}
										>
											<div
												style={{
													color: "#FFF",
													fontWeight: 600,
													margin: "auto 0",
												}}
											>
												<div>
													{getCraftLetter(craft.description, craft.code)}
												</div>
											</div>
										</div>
									</div>
									<div style={{ marginLeft: 10 }}>{craft.description}</div>
								</Grid2>
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</Box>
	);
};
